export enum MachineUsage {
  Public = 'Public',
  SemiPublic = 'SemiPublic',
  PrivateHouse = 'PrivateHouse',
  SharedBuilding = 'SharedBuilding'
}

// Helper function to check if usage is private or multi-residential
export const isPrivateOrMR = (usage: MachineUsage): boolean => {
  return usage === MachineUsage.PrivateHouse || usage === MachineUsage.SharedBuilding;
};

export interface ActorTree {
  actorId: number;
  name?: string;
  parentActorId?: number;
  machinesCount?: number;
  machineUsage?: MachineUsage;
  actorTypeId?: number;
}

// Simplified interface for actor data with only actorId and name
export interface ActorSummary {
  actorId: number;
  name?: string;
}

// Factory function to create an empty ActorTree with just actorId
export const createEmptyActorTree = (actorId: number): ActorTree => ({
  actorId
});

// Factory function to create ActorTree from JSON
export const createActorTreeFromJson = (json: Record<string, any>): ActorTree => ({
  actorId: json.actorId,
  name: json.name,
  parentActorId: json.parentActorId,
  machinesCount: json.machinesCount,
  machineUsage: json.machineUsage ? MachineUsage[json.machineUsage as keyof typeof MachineUsage] : undefined,
  actorTypeId: json.actorTypeId
});

// V2 hierarchy response item
export interface ActorHierarchyItem {
  actorId: number;
  name: string | null;
  parentActorId?: number | null;
  parentActorName?: string | null;
  innerLevel: number;
  hierarchyPath?: string | null;
  currentA: number;
  bufferA: number;
  powerKw: number;
  bufferKw: number;
  minCurrentA: number;
  actualCurrentA: number;
  actualPhase1A: number;
  actualPhase2A: number;
  actualPhase3A: number;
  allocatedCurrentA: number;
  limitCurrentA: number;
  capacityRatio: number;
  capacityPercent: number;
  totalMachines: number;
  machinesInSession: number;
  geoCity?: string | null;
  geoState?: string | null;
  geoCountry?: string | null;
  createdDt: string;
  updatedDt?: string | null;
}

// Map V2 ActorHierarchyItem to legacy ActorTree shape
export const createActorTreeFromHierarchyItem = (item: ActorHierarchyItem): ActorTree => ({
  actorId: item.actorId,
  name: item.name ?? undefined,
  parentActorId: item.parentActorId ?? undefined,
  machinesCount: item.totalMachines,
}); 